/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Status_GraceInputs */



/**
* | output |
* | --- |
* | "Payment overdue" |
*
* @param {Plan_Status_GraceInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const plan_status_grace = /** @type {((inputs?: Plan_Status_GraceInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Status_GraceInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оплата просрочена")
	return /** @type {LocalizedString} */ ("Payment overdue")
});